import { Component } from '@angular/core';
import { OauthService } from '../services/oauth.service';
import { ContextService } from '../services/context.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-oauth-callback',
  imports: [],
  templateUrl: './oauth-callback.component.html',
  styleUrl: './oauth-callback.component.css'
})
export class OauthCallbackComponent {

  constructor(private oauth: OauthService, private contextService: ContextService, private router: Router) {}

  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);

    const code = params.get('code');
    const error = params.get('error');
    const state = params.get('state');

    if (error) {
      console.error('OAuth authorization failed:', error);
      return;
    }

    if (!code || !state) {
      console.error('Missing code or state in OAuth callback');
      return;
    }

    console.log('params', params.toString());

    // Safely decode state
    let context: any;
    try {
      context = JSON.parse(atob(state));
    } catch (e) {
      console.error('Invalid OAuth state', e);
      return;
    }

    console.log('context', context);

    // Send code to Lambda
    this.oauth.handleOAuthCallback(code, context).subscribe({
      next: () => {
        this.oauth.finishOAuth();
        this.contextService.setContext(context);
        // Clean URL
        history.replaceState({}, '', '/');

        // Continue app flow
        this.router.navigate(['/']);
      },
      error: err => {
        // this.oauth.finishOAuth();
        console.error('OAuth token exchange failed', err);
      }
    });
  }

}
